import { render } from "./HandModal.vue?vue&type=template&id=3df932b9"
const script = {}

import "./HandModal.vue?vue&type=style&index=0&id=3df932b9&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__